<script>

</script>

<div class="mb-5">
    <h1>Σφάλμα λογαριασμού</h1>
    <div class="heading-separator"></div>
</div>
<div class="page-icon danger mb-5">
    <i class="fa fa-user-o"></i>
</div>
<div class="text-center mb-5">
    <p><strong>Ο λογαριασμός σας δεν είναι ενεργός!</strong></p>
    <p>Για περισσότερες πληροφορίες επικοινωνήστε με την γραμματεία του Π.Κ.Σ.</p>
</div>